import * as Yup from 'yup'
import { useFormik } from 'formik'
import useTranslations from '../../../i18n/useTranslations'
import { autocompleteAddressPropType } from '../../../common/propTypes'
import { setFormikStateAndValidate } from '../../../libs/formik'
import useEnhancedFormik from '../../../hooks/useEnhancedFormik'

import { addressDataToString } from '../../business'
import { isValidPhoneNumber } from 'react-phone-number-input'

const useAddressEdtionForm = (
  initialValues,
  serverErrors,
  handleSubmitEdition,
  currentStep
) => {
  const t = useTranslations()

  const AddressSchema = Yup.object().shape({
    id: Yup.string().required(),
    name: Yup.string().required(),
    address: Yup.string().required(),
    autocompleteAddress: Yup.string().required(),
    route: Yup.string().nullable(),
    streetNumber: Yup.string().nullable(),
    stair: Yup.string(),
    floor: Yup.string(),
    letter: Yup.string(),
    country: Yup.string().required(),
    city: Yup.string().required(),
    postalCode: Yup.string().required(),
    phonePrefix: Yup.string().required(),
    phone: Yup.string()
    .required()
    .test(
      'isValidPhoneNumber',
      {
        key: 'shipping-send-form:new-address:phone-format-or-length-error',
      },
      function (value, schema) {
        const phonePrefix = schema.parent.phonePrefix
        const fullPhoneNumber = phonePrefix+value
        return isValidPhoneNumber(fullPhoneNumber)
      },
    ),
    email: Yup.string().email(),
    comments : Yup.string(),
    contactClientCode: Yup.string()
  })

  const formik = useFormik({
    validationSchema: AddressSchema,
    initialValues,
    onSubmit: values => {
      // NOTE: Add stair, floor, letter info to address data
      const address = addressDataToString(values, t)
      handleSubmitEdition({ ...values, address })
    },
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true
  })

  //REVIEW
  const enhancedFormik = useEnhancedFormik(
    autocompleteAddressPropType,
    formik,
    { fieldErrors: formik.errors, errors: serverErrors },
  )
  
  const handleChangeAutocompleteAddress = async autocompleteData =>
    await setFormikStateAndValidate(formik, state => ({
      values: {
        ...state.values,
        ...autocompleteData,
        // NOTE: Add route and streetNumber info to address data
        address: addressDataToString(autocompleteData, t),
      },

      touched: {
        ...state.touched,
        address: true,
        route: true,
        contactClientCode: true,
        streetNumber: true,
        country: true,
        city: true,
        postalCode: true,
        phone:true
      },
    }))

  const handleTouchedAutocompleteAddress = () =>
    setFormikStateAndValidate(formik, state => ({
      ...state,
      touched: {
        ...state.touched,
        address: true,
        route: true,
        contactClientCenter: true,
        streetNumber: true,
        country: true,
        city: true,
        postalCode: true,
        phone:true
      },
    }))

  return {
    formik,
    enhancedFormik,
    handleChangeAutocompleteAddress,
    handleTouchedAutocompleteAddress,
  }
}

export default useAddressEdtionForm
